import { NgModule } from '@angular/core';

import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { NewHygieneCheckComponent } from './new-hygiene-check/new-hygiene-check.component';
import { HygieneCheckListComponent } from './hygiene-check-list/hygiene-check-list.component';
import { HygieneCheckEditorComponent } from './hygiene-check-editor/hygiene-check-editor.component';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';
import { HygieneCheckQuestionnaireEditorComponent } from './hygiene-check-questionnaire-editor/hygiene-check-questionnaire-editor.component';
import { HygieneCheckQuestionnairePreviewComponent } from './hygiene-check-questionnaire-preview/hygiene-check-questionnaire-preview.component';
import { HygieneCheckQuestionManagerComponent } from './hygiene-check-question-manager/hygiene-check-question-manager.component';
import { PhBhpUiModule } from "../../../ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module";
import { HygieneCheckCountryEditorComponent } from './hygiene-check-country-editor/hygiene-check-country-editor.component';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';


import { HygieneCheckEvaluationComponent } from '../../../ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation/hygiene-check-evaluation.component';
import { HygieneCheckEvaluationQuickcommentsComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-quickcomments/hygiene-check-evaluation-quickcomments.component';
import { HygieneCheckEvaluationComplianceComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-compliance/hygiene-check-evaluation-compliance.component';
import { HygieneCheckEvaluationIndividualDataComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-individual-data/hygiene-check-evaluation-individual-data.component';
import { HygieneCheckEvaluationOverallComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-overall/hygiene-check-evaluation-overall.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { HygieneCheckPdfReportComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-pdf-report/hygiene-check-pdf-report.component';
import { PHBHPFeaturePackageEvaluationModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';

@NgModule({
  declarations: [
    NewHygieneCheckComponent,
    HygieneCheckListComponent,
    HygieneCheckEditorComponent,
    HygieneCheckCountryEditorComponent,
    HygieneCheckQuestionnaireEditorComponent,
    HygieneCheckQuestionnairePreviewComponent,
    HygieneCheckQuestionManagerComponent,
    HygieneCheckEvaluationComponent,
    HygieneCheckEvaluationQuickcommentsComponent,
    HygieneCheckEvaluationComplianceComponent,
    HygieneCheckEvaluationOverallComponent,
    HygieneCheckEvaluationIndividualDataComponent,
    HygieneCheckPdfReportComponent
  ],
  imports: [
    PHBHPLayoutPackageModule,
    PHBHPLocalizePackageModule,
    ClientLibModule,
    PhBhpFeatureComponentsModule,
    PhBhpUiModule,
    MatSlideToggleModule,
    DragDropModule,
    TextFieldModule,
    ExcelExportModule,
    DropDownsModule,
    PDFExportModule,
    PHBHPFeaturePackageEvaluationModule,
  ],
  exports: [
    HygieneCheckEvaluationComponent,
    HygieneCheckEvaluationQuickcommentsComponent,
    HygieneCheckEvaluationComplianceComponent,
    HygieneCheckEvaluationOverallComponent,
    HygieneCheckEvaluationIndividualDataComponent,
    HygieneCheckPdfReportComponent
  ]
})
export class PHBHPFeaturePackageCheckModule { }
